import { render, staticRenderFns } from "./ConvoEndLogic.vue?vue&type=template&id=51b108a8&scoped=true&"
import script from "./ConvoEndLogic.vue?vue&type=script&lang=js&"
export * from "./ConvoEndLogic.vue?vue&type=script&lang=js&"
import style0 from "./ConvoEndLogic.vue?vue&type=style&index=0&id=51b108a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b108a8",
  null
  
)

export default component.exports